export default {
  apiEndpoint: 'https://api.clickin.fr',
  domainName: 'https://clickin.fr',
  stripeApiKey: 'pk_live_Bvpubd682LDuJGToAB1ulCHJ00yA6HbBUD',
}
